import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { scrollToId } from '../../utils/scroll';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-white/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-207" data-mp="2nvndlcnqrafm">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-208" data-mp="2svrwf9c4gh90">
        <div data-id="element-209" data-mp="2stoups1lwzog">
          <p className="font-heading text-sm font-bold text-navy" data-id="element-210" data-mp="2styn1ma4jixb">19€</p>
          <p className="text-[11px] text-muted" data-id="element-211" data-mp="o2e7xwaywqpr">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} onClick={() => scrollToId('oferta')} data-id="element-212" data-mp="s2y3ivfw7m9s">
          Acceso Ahora
        </PrimaryButton>
      </div>
    </div>;
}